import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import CancelIcon from '@material-ui/icons/Cancel';
import './styles/_notice.scss';

let timeoutHandle = null;

export default function notice(
	label,
	status = 'error',
	timeout = 4000,
	position = 'top'
) {
	clearTimeout(timeoutHandle);
	ReactDOM.unmountComponentAtNode(document.getElementById('notice'));
	ReactDOM.render(
		<Notice label={label} status={status} timeout={timeout} position={position} />,
		document.getElementById('notice')
	);
	timeoutHandle = setTimeout(() => {
		ReactDOM.unmountComponentAtNode(document.getElementById('notice'));
	}, timeout);
}

function Notice({ status, position, label }) {
	const [display, setDisplay] = useState('');

	let style = {};

	switch (status) {
		case 'error':
			style = { display: display, backgroundColor: '#d32f2f' };
			break;
		case 'info':
			style = { display: display, backgroundColor: '#859de0' };
			break;
		case 'success':
			style = { display: display, backgroundColor: '#319631' };
			break;
		case 'warning':
			style = { display: display, backgroundColor: '#ffa500' };
			break;
		default:
			style = { display: display, backgroundColor: '#d32f2f' };
	}

	switch (position) {
		case 'bottom':
			style = { ...style, top: 'auto', bottom: '15px' };
			break;
		default:
			break;
	}

	return (
		<div className={'notice'} style={style}>
			<div className={'notice-div'}>{label}</div>
			<button className="notice-button" onClick={() => setDisplay('none')}>
				<CancelIcon />
			</button>
		</div>
	);
}
